import React from "react"
import autobind from "class-autobind"
import Dropzone from "react-dropzone"
import strings from "../../localization/strings"
import { grey200 } from "material-ui/styles/colors"
import AppStateStore from "../../stores/AppStateStore"
interface IProps {
    errorCSVFile?: string
    handleChooseFile(fileName: string, csvFileData: any, csvFile: File): void
}
interface IState {
    choosenFile: any
}

export default class ChooseCSVFile extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            choosenFile: null
        }
        autobind(this)
    }

    handleParseFile() {
        return new Promise((resolve, reject) => {
            let uploadFileData: string[][] = [[]]
            if (!this.state.choosenFile) {
                resolve(uploadFileData)
            }
            else {
                const reader = new FileReader()
                reader.readAsBinaryString(this.state.choosenFile)
                reader.onload = () => {
                    const strData = reader.result.toString().replace('ï»¿', '')
                    const strDelimiter = ","
                    const objPattern = new RegExp(
                        (
                            // Delimiters.
                            "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +
                            // Quoted fields.
                            "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
                            // Standard fields.
                            "([^\"\\" + strDelimiter + "\\r\\n]*))"
                        ), "gi"
                    )

                    let arrMatches = null
                    while (arrMatches = objPattern.exec(strData)) {
                        var strMatchedDelimiter = arrMatches[1]
                        strMatchedDelimiter.length && strMatchedDelimiter !== strDelimiter &&
                            uploadFileData.push([])
                        const strMatchedValue = arrMatches[2] ? arrMatches[2].replace(new RegExp("\"\"", "g"), "\"") : arrMatches[3]
                        uploadFileData[uploadFileData.length - 1].push(strMatchedValue)
                        resolve(uploadFileData)
                    }
                }
            }
        })
    }

    async handleChooseFile() {
        let uploadFileData = await this.handleParseFile() as string[][]
        uploadFileData = uploadFileData.filter(row => row.filter(col => col ? true : false).length > 0)
        this.props.handleChooseFile(this.state.choosenFile.name, uploadFileData, this.state.choosenFile)
    }

    render() {
        const border = this.props.errorCSVFile ? "1px dashed red" : "dashed 1px #cccccc"
        return (
            <Dropzone
                data-intercom-target={"OpenFileUploadSelection"}
                accept=".csv"
                onDrop={files => files.length ?
                    this.setState({ choosenFile: files[0], }, () =>
                        this.handleChooseFile()
                    ) :
                    AppStateStore.setAlertDialogContent({
                        title: strings.This_file_format_is_not_supported,
                        content: strings.Supported_file_types + ": .csv"
                    })
                }
                style={{
                    height: 70,
                    width: 275,
                    border: border,
                    fontSize: 15,
                    textAlign: "center",
                    backgroundColor: grey200,
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    paddingLeft: 10,
                    paddingRight: 40
                }}
                activeStyle={{
                    border: "dashed 1px #666666",
                    background: "#e7e7e7"
                }}
            >
                <span>
                    {this.state.choosenFile ? this.state.choosenFile.name.split('.')[0].trim() : strings.Drag_and_Drop_or_click_to_choose_a_file}
                </span>
                <div style={{ position: "absolute", right: 15 }}>
                    <i className="fa fa-upload" style={{ fontSize: 27 }} />
                </div>
            </Dropzone>
        )
    }
}
